import Vue           from 'vue'
import App           from '@/App.vue'
import router        from '@/services/router'
import vuetify       from '@/plugins/vuetify';

import { createPinia, PiniaVuePlugin } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'

import '@/plugins/download'
import '@/plugins/dayjs'
import '@/plugins/apexchart'
import '@/plugins/api'
import '@/plugins/build'
import '@/plugins/storage'
import '@/plugins/user'

//import VueSignaturePad from 'vue-signature-pad';
//Vue.use(VueSignaturePad);

/**************** Pinia   **********************/
Vue.use(PiniaVuePlugin)
export const pinia = createPinia()
const piniaStore = createPersistedState({
  key: id => `__persisted__${id}`
})
pinia.use(piniaStore)


Object.defineProperty(Vue.prototype, '$project', { pro_id:0, pro_obt_id_phyto:0 }) //Vue.use(AuthPlugin, { router: router })

// Event bus
Vue.prototype.$eventBus = new Vue({})

new Vue({
  vuetify,
  router,
  pinia,
  render: h => h(App)
}).$mount('#app')


// Register our service worker (on désactive le service worker pour ios)
if ( (process.env.NODE_ENV === 'production') && ('serviceWorker' in navigator) ) { //&& !isIOS() 
  navigator.serviceWorker.register('./sw.js').then(reg => {
    
    // On écoute si un nouveau SW arrive
    reg.addEventListener('updatefound', () => {
      const newWorker = reg.installing;
      
      newWorker.addEventListener('statechange', () => {
        // Si le nouveau SW est installé et prêt (mais attend)
        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
          // ICI : Affiche ton interface (ex: un bouton "Mettre à jour")
          showUpdateBar();
        }
      });
    });
  });
} else if ('serviceWorker' in navigator) {
  // En DEV : On force la désinstallation pour éviter les effets de bord
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (let registration of registrations) {
      registration.unregister();
      console.log('SW désinstallé (Mode Dev)');
    }
  });
}

function showUpdateBar() {
  const confirmUpdate = confirm("Une nouvelle version est disponible. Voulez-vous recharger la page ?");
  if (confirmUpdate) {
    window.location.reload();
  }
}